var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1324 19.6163H20.9594M3.30554 19.6163H4.94788C5.42766 19.6163 5.66754 19.6163 5.89329 19.5621C6.09344 19.514 6.28478 19.4348 6.46028 19.3272C6.65823 19.2059 6.82786 19.0363 7.16711 18.697L19.4883 6.3759C20.3008 5.5634 20.3008 4.24609 19.4883 3.43359C18.6758 2.62109 17.3584 2.6211 16.546 3.43359L4.22478 15.7547C3.88553 16.094 3.7159 16.2636 3.59459 16.4616C3.48705 16.6371 3.40779 16.8284 3.35974 17.0286C3.30554 17.2543 3.30554 17.4942 3.30554 17.974V19.6163Z",
    stroke: "black",
    strokeWidth: 1.96154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/edit-black.a23983ef98603cff9ef125c0ff23d8dd.svg";
export { ForwardRef as ReactComponent };